import { render, staticRenderFns } from "./GrupoDeInteres.vue?vue&type=template&id=4768a81a&"
import script from "./GrupoDeInteres.vue?vue&type=script&lang=ts&"
export * from "./GrupoDeInteres.vue?vue&type=script&lang=ts&"
import style0 from "./GrupoDeInteres.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('4768a81a', component.options)
    } else {
      api.reload('4768a81a', component.options)
    }
    module.hot.accept("./GrupoDeInteres.vue?vue&type=template&id=4768a81a&", function () {
      api.rerender('4768a81a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/plataforma/GrupoDeInteres.vue"
export default component.exports